import { GetColumnProductQuery } from 'data/__generated__';
import { apolloClient } from '../../../App';
import { GET_COLUMN_PRODUCT_QUERY } from 'data/queries/product';

export const productStockUpdatedHandler = (updatedProduct: { _id: string; stock: number }, columnId: string) => {
    const { _id: productId, stock } = updatedProduct;

    const cachedData = apolloClient.readQuery<GetColumnProductQuery>({
        query: GET_COLUMN_PRODUCT_QUERY,
        variables: { columnId, productId },
    });

    if (cachedData?.columnProduct) {
        apolloClient.writeQuery<GetColumnProductQuery>({
            query: GET_COLUMN_PRODUCT_QUERY,
            variables: { columnId, productId },
            data: {
                columnProduct: {
                    ...cachedData.columnProduct,
                    stock,
                },
            },
        });
    }
};
